import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DashboardCardComponent } from '@shared/components/dashboard-card/dashboard-card.component';

@Component({
  selector: 'app-unit-home-attendance-card',
  standalone: true,
  imports: [RouterLink, MatButtonModule, MatIconModule, DashboardCardComponent],
  templateUrl: './unit-home-attendance-card.component.html',
  styleUrl: './unit-home-attendance-card.component.scss',
})
export class UnitHomeAttendanceCardComponent {
  @Input({ required: true }) unitId = '';
}
